export { default as ProductViewDescription } from './ProductViewDescription'
